import { RaRecord, regex, required, TranslateFunction } from "react-admin";

import { httpClient } from "./dataProvider";
import { apiEndpoint } from "./settings";

export function validUrl() {
  return (value: string) => {
    if (!value) return;
    if (value && (value.startsWith("http://") || value.startsWith("https://"))) {
      return;
    } else {
      return "validations.url";
    }
  };
}

export const validSlugChars = (translate: TranslateFunction) =>
  regex(/^[a-z0-9-_]+$/, translate("validations.slug_chars"));

export const validateEventNumber = async (value: string) => {
  if (!value) {
    return "ra.validation.required";
  }

  const result: { json: { results: RaRecord[] } } = await httpClient(`${apiEndpoint}/events/?search=${value}`);

  if (result.json.results.length > 0) {
    return "ra.validation.not_unique";
  }

  return undefined;
};

export const validateRequired = required();
